import { render, staticRenderFns } from "./odemearaci.vue?vue&type=template&id=51b69f46&"
import script from "./odemearaci.vue?vue&type=script&lang=js&"
export * from "./odemearaci.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports